var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9C2 4.58172 5.58172 1 10 1H42C46.4183 1 50 4.58172 50 9V41C50 45.4183 46.4183 49 42 49H10C5.58172 49 2 45.4183 2 41V9Z",
    fill: "#EEC1FC",
    shapeRendering: "crispEdges"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.5H42C46.1421 1.5 49.5 4.85786 49.5 9V41C49.5 45.1421 46.1421 48.5 42 48.5H10C5.85786 48.5 2.5 45.1421 2.5 41V9C2.5 4.85786 5.85787 1.5 10 1.5Z",
    stroke: "#CB34FC",
    shapeRendering: "crispEdges"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0H20L26 6V28C26 29.1046 25.1046 30 24 30H2C0.8954 30 0 29.1046 0 28V2C0 0.8954 0.8954 0 2 0Z",
    fill: "#CB34FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0V6H26",
    fill: "#CB34FC"
  }), /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 21,
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fontWeight: "bold"
  }, "PDF"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportPdf);
export default __webpack_public_path__ + "static/media/export-pdf.9934824af6789be38bdec3aa500bf870.svg";
export { ForwardRef as ReactComponent };